import { Gift, Share2, BadgePercent } from "lucide-react";
import Reveal from "./Reveal";
import { scrollToId } from "./Header";

const STEPS = [
    {
        icon: Gift,
        title: "Get your code",
        body: "Submit your first enquiry and you automatically receive a personal referral code, shown instantly and sent to your email.",
    },
    {
        icon: Share2,
        title: "Share it",
        body: "Pass your code to other researchers. They enter it in the referral field when they submit their first enquiry.",
    },
    {
        icon: BadgePercent,
        title: "Earn credit",
        body: "When their first order is confirmed, you receive credit towards your next order — applied when we reply with pricing.",
    },
];

export default function Referral() {
    return (
        <section id="referral" data-testid="referral-section" className="py-16 md:py-24 px-4 sm:px-6 lg:px-8 max-w-7xl mx-auto">
            <Reveal>
                <div className="rounded-3xl bg-slate-900 text-slate-100 p-8 sm:p-12 overflow-hidden relative">
                    <div className="absolute -top-24 -right-24 w-72 h-72 rounded-full bg-cyan-500/10 blur-3xl" aria-hidden="true" />
                    <div className="relative">
                        <div className="font-jbm text-xs uppercase tracking-[0.25em] text-cyan-400 mb-3">06 — Referral program</div>
                        <h2 className="font-display text-2xl sm:text-3xl lg:text-4xl font-semibold tracking-tight max-w-2xl">
                            Refer a lab, earn credit on your next order
                        </h2>
                        <div className="mt-10 grid sm:grid-cols-3 gap-5">
                            {STEPS.map((s, i) => (
                                <Reveal key={s.title} delay={0.1 + i * 0.08}>
                                    <div className="h-full bg-slate-800/60 border border-slate-700/60 rounded-2xl p-6 hover:border-cyan-500/50 transition-colors duration-300">
                                        <div className="w-11 h-11 rounded-full bg-cyan-500/10 border border-cyan-500/30 flex items-center justify-center mb-5">
                                            <s.icon className="w-5 h-5 text-cyan-400" />
                                        </div>
                                        <div className="font-jbm text-[10px] uppercase tracking-widest text-slate-500 mb-2">Step {i + 1}</div>
                                        <h3 className="font-display text-lg font-semibold tracking-tight">{s.title}</h3>
                                        <p className="text-sm leading-relaxed text-slate-400 mt-2">{s.body}</p>
                                    </div>
                                </Reveal>
                            ))}
                        </div>
                        <button
                            data-testid="referral-start-button"
                            onClick={() => scrollToId("#enquiry")}
                            className="mt-10 inline-flex items-center gap-2.5 bg-white text-slate-900 font-medium px-7 py-3.5 rounded-full hover:bg-cyan-100 transition-colors duration-300"
                        >
                            <Gift className="w-4 h-4" />
                            Submit an enquiry to get your code
                        </button>
                    </div>
                </div>
            </Reveal>
        </section>
    );
}
